import React, { memo } from "react";
import { consts } from "../../../../shim/jsbridge";
import { LOCATION } from "../../consts";
import GridAvailabilityIcon from "../../../../components/GridAvailabilityIcon";
import { getAvailabilityIconAndTitle } from "../../util";

const { ticloud_max_fetch_file_size: ticloudMaxFetchFileSize } = consts || {};

type AvailableProps = {
  notFoundView?: string | boolean;
  data: {
    location: string;
    sample_available: boolean;
    sample_size?: number;
    int_submission_analyzer?: number;
    date_submission_time?: Date;
  };
};

const Available = ({ notFoundView, data }: AvailableProps) => {
  if (notFoundView) return null;

  const { icon, title } = getAvailabilityIconAndTitle(
    data.location === LOCATION.CLOUD,
    data.sample_available,
    (data.sample_size ?? 0) > ticloudMaxFetchFileSize,
    data.int_submission_analyzer,
    !data.date_submission_time
  );

  return (
    <GridAvailabilityIcon
      icon={icon}
      message={title}
      id="sample_availability"
    />
  );
};

export default memo(Available);
